var spoiler_default = {
  "fontElementMap": "QV2Si",
  "hideText": "x5zal",
  "onHoverText": "ldzdB",
  "hideBlock": "Cmo11",
  "smallBlur": "_0PuXX",
  "mediumBlur": "vYAt0",
  "largeBlur": "x-kOV",
  "hideBlock_gallery": "gQ0Bb",
  "overlay": "W8urx",
  "overlay_gallery": "Fv8vp",
  "revealSpoilerBtn": "_9shk-",
  "isMobile": "AuAcM",
  "onHoverBtn": "pL0SE",
  "spoilerWrapper": "g20fh",
  "spoilerDescription": "fNC7q",
  "spoilerContainer": "rPx4-",
  "spoilerContainer_Gallery": "_3HK3d"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
